export const skills = [
    {
        id: 1,
        name: 'HTML',
        icon: 'entypo:code'
    },
    {
        id: 2,
        name: 'CSS',
        icon: 'simple-icons:css3'
    },
    {
        id: 3,
        name: 'JavaScript',
        icon: 'simple-icons:javascript'
    },
    {
        id: 4,
        name: 'React',
        icon: 'simple-icons:react'
    },
    {
        id: 5,
        name: 'Redux',
        icon: 'simple-icons:redux'
    }
];